import { render, staticRenderFns } from "./StudentQuestionsImgNeutral.vue?vue&type=template&id=61380af7"
import script from "./StudentQuestionsImgNeutral.vue?vue&type=script&lang=ts"
export * from "./StudentQuestionsImgNeutral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports